module.exports = __webpack_public_path__ + "templates/modal-email-restore-tpl.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/plugins/login/templates/modal-email-restore-tpl.html
// module id = UjJ9
// module chunks = 1